import unsavedContent from '@/mixins/unsaved-content'

export default {
  mixins: [unsavedContent],
  hasUnsavedAttachmentsKey: 'hasUnsavedAttachmentsKey',
  beforeDestroy: function () {
    this._setHasUnsavedAttachments(false)
    this._setUnsavedContent(false)
  },

  watch: {
    numAttachments: function () {
      if (!this.stateObjectKey) {
        return
      }

      this._setHasUnsavedAttachments(this.numAttachments > 0)
    },

    'body.length': function (value) {
      if (!this.stateObjectKey) {
        return
      }

      this._setUnsavedContent((value || 0) > 0)
    }
  },

  computed: {
    hasUnsavedAttachments: function () {
      const attachObject = this._get(this.hasUnsavedAttachmentsKey)
      if (attachObject) {
        const hasUnsaved = Object.values(this._get(this.hasUnsavedAttachmentsKey, {})).filter((value) => value).length > 0
        return hasUnsaved
      }
      return false
    }
  },

  methods: {
    _setHasUnsavedAttachments: function (hasUnsaved) {
      const unsavedAttachLength = Object.assign({}, this._get(this.hasUnsavedAttachmentsKey, {})) // need a copy to avoid mutating state
      unsavedAttachLength[this._uid] = hasUnsaved
      this._set(this.hasUnsavedAttachmentsKey, unsavedAttachLength)
    }
  }
}
